<div>
    <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="cancel()">
            <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">Status History</h4>
    </div>
    <div class="form-group modal-body">
        <dx-data-grid id="gridContainer"
                      [dataSource]="alertEvents"
                      [showRowLines]="true"
                      [showBorders]="true"
                      [rowAlternationEnabled]="true"
                      [masterDetail]="{ enabled: true, template: 'detail' }">
            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
            <dxi-column dataField="Status" caption="Status" cellTemplate="alertEventStatusTemplate" width="100"></dxi-column>
            <div *dxTemplate="let cell of 'alertEventStatusTemplate'">
                <div>
                    <app-status-traffic-light [status]="cell.data.Status"></app-status-traffic-light>
                </div>
            </div>
            <dxi-column dataField="CreatedDate" dataType="date" [format]="dateTimeService.getDevExpressDateTimeFunction" width="155"></dxi-column>
            <dxi-column dataField="Comment" caption="Comment [Hover to see full message]" dataType="string"></dxi-column>

            <div *dxTemplate="let cell of 'detail'">
                <div class="detail__frame">
                    <div class="detail-group detail-group__body">
                        <label>Comment</label>
                        <textarea readonly>{{ cell.data.Comment }}</textarea>
                    </div>
                </div>
                <br/>
                <dx-data-grid
                            [dataSource]="cell.data.SentMails"
                            [showRowLines]="true"
                            [showBorders]="true"
                            [rowAlternationEnabled]="true">
                    <dxi-column dataField="To" caption="Receiver" width="25%"></dxi-column>
                    <dxi-column dataField="Subject" dataType="string" width="30%"></dxi-column>
                    <dxi-column dataField="Body" width="45%" cellTemplate="detailView"></dxi-column>

                    <ng-container *dxTemplate="let cell of 'detailView'">
                        <div class="detail__frame">
                    
                            <div class="detail-group detail-group__body">
                                <label>Body</label>
                                <textarea readonly>{{ cell.data.Body }}</textarea>
                            </div>
                    
                        </div>
                      </ng-container>

                </dx-data-grid>
            </div>
            
        </dx-data-grid>
    </div>
</div>